import { render, staticRenderFns } from "./addConsumer.vue?vue&type=template&id=5ebb1abf&scoped=true&"
import script from "./addConsumer.vue?vue&type=script&lang=js&"
export * from "./addConsumer.vue?vue&type=script&lang=js&"
import style0 from "./addConsumer.vue?vue&type=style&index=0&id=5ebb1abf&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ebb1abf",
  null
  
)

export default component.exports